import { readLocalStorage } from "./local-storage";
import { loadVerity } from "../../Views/Shared/Components/CommonJs/verity.js";

document.addEventListener('DOMContentLoaded', () => {
    const ppid = readLocalStorage('PPID');

    loadVerity(ppid);
});